import React from "react";
import ReporteVendedoresVentas from "../components/ReporteVendedoresVentas";

const InformeVendedoresVentas = () => {
  return (
    <>
      <ReporteVendedoresVentas />
    </>
  );
};

export default InformeVendedoresVentas;